module.exports = __webpack_public_path__ + "img/icons8-honda.860a59a2.svg";